import React from 'react';
import AboutContent from '../components/about/AboutContent';

const About = () => {
  return <AboutContent />;
};

export default About;
